var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDressactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.56,846.58C805.7,785.46,736.68,612.74,696.93,512H326.52c-38.22,96.25-108.11,273.49-129,334.56a16,16,0,0,0,12.15,20.9A1616.37,1616.37,0,0,0,512,896a1616.36,1616.36,0,0,0,302.39-28.54A16,16,0,0,0,826.56,846.58Z",
    style: {
      fill: "#006eff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.89,448H679.11l23.12-208.1A14.31,14.31,0,0,0,688,224q-20.16,0-40,1.9V136a8,8,0,0,0-8-8H592a8,8,0,0,0-8,8V237.1a412.76,412.76,0,0,0-57.94,19.6Q519,259.7,512,263q-7-3.24-14.06-6.25A414.59,414.59,0,0,0,448,239.24V136a8,8,0,0,0-8-8H392a8,8,0,0,0-8,8v90.73A420.3,420.3,0,0,0,336,224h-.27a14.33,14.33,0,0,0-14,15.91Z",
    style: {
      fill: "#006eff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDressactive);
export default __webpack_public_path__ + "static/media/dressactive.82207ad98a200987ae301766e14e60aa.svg";
export { ForwardRef as ReactComponent };